import { gql } from '@apollo/client'
import { ID } from '../IQueryData'
import {
  IBulkParkingPoolActionPayload,
  BULK_PARKING_POOL_ACTION_FIELDS,
} from './bulkParkingPoolAction'

export interface IBulkUnassignFromParkingPoolVars {
  parkingPool: ID
  logins: string[]
}

export interface IBulkUnassignFromParkingPoolData {
  bulkUnassignFromParkingPool: IBulkParkingPoolActionPayload
}

export const BULK_UNASSIGN_FROM_PARKING_POOL = gql`
  mutation bulkUnassignFromParkingPool($parkingPool: ID!, $logins: [String!]!) {
    bulkUnassignFromParkingPool(parking_pool: $parkingPool, logins: $logins) {
      ${BULK_PARKING_POOL_ACTION_FIELDS}
    }
  }
`
